import React, { useState, useEffect } from 'react';
import { Modal, Button, Row, Col, Form, Container } from 'react-bootstrap';
import POServices from '../../../services/PoServices';
import Swal from 'sweetalert2';

const QuatationModal = ({ show, handleClose, data }) => {
    console.log("datamodal", data);

    const [suppliers, setSuppliers] = useState([]);
    const [sending, setSending] = useState(false);
    const [selectedSuppliers, setSelectedSuppliers] = useState([]);
    const [editedDescriptions, setEditedDescriptions] = useState({});
    const [supplierSearch, setSupplierSearch] = useState("");
    const [quotationData, setQuotationData] = useState(null);
    const [selectedItems, setSelectedItems] = useState([]);



    const fetchSuppliers = async () => {
        try {
            const res = await POServices.activeSuppliers();
            setSuppliers(res?.data || []);
        } catch (err) {
            console.error("Failed to fetch suppliers", err);
        }
    };

    useEffect(() => {
        if (show) {
            fetchSuppliers();
            setSelectedSuppliers([]); // start unchecked
            setSupplierSearch("");    // reset search
        }
    }, [show]);

    const handleSupplierCheck = (supplier, checked) => {
        setSelectedSuppliers((prev) => {
            if (checked) {
                return [...prev, supplier];
            } else {
                return prev.filter((s) => s._id !== supplier._id);
            }
        });
    };

    // 🔹 Format supplier label as: Name | Contact | Mobile | City
    const formatSupplierLabel = (supplier) => {
        const parts = [];

        if (supplier?.name) parts.push(supplier.name);
        if (supplier?.contactPerson) parts.push(supplier.contactPerson);

        if (Array.isArray(supplier?.mobileNo) && supplier.mobileNo.length > 0) {
            parts.push(supplier.mobileNo[0]); // show first mobile
        }

        if (supplier?.address?.city) parts.push(supplier.address.city);

        return parts.join(" | ");
    };

    const filteredSuppliers = suppliers.filter((supplier) =>
        supplier.name.toLowerCase().includes(supplierSearch.toLowerCase())
    );



    const getValidWhatsAppNumber = (mobileNoArray) => {
        if (!Array.isArray(mobileNoArray) || mobileNoArray.length === 0) return null;

        // Take first mobile number
        let num = mobileNoArray[0];

        // Remove everything except digits
        num = num.replace(/\D/g, "");

        // Remove leading 0 (Indian numbers)
        if (num.startsWith("0")) {
            num = num.substring(1);
        }

        // If already starts with 91 and length is 12 → OK
        if (num.startsWith("91") && num.length === 12) {
            return num;
        }

        // If 10-digit Indian number → prepend 91
        if (num.length === 10) {
            return `91${num}`;
        }

        // ❌ Invalid number
        return null;
    };

    useEffect(() => {
        if (show && data?._id) {
            POServices.getQuotationByRequisition(data._id)
                .then(res => {
                    setQuotationData(res.data.data);
                })
                .catch(() => {
                    setQuotationData(null);
                });
        }
    }, [show, data]);

    const handleSendQuotation = async () => {
        try {
            // 🔒 Prevent double click
            if (sending) return;

            // 1️⃣ Validate item selection FIRST
            if (selectedItems.length === 0) {
                Swal.fire(
                    "Warning",
                    "Please select at least one Part Number",
                    "warning"
                );
                return;
            }

            // 2️⃣ Validate supplier selection
            if (selectedSuppliers.length === 0) {
                Swal.fire(
                    "Warning",
                    "Please select at least one supplier",
                    "warning"
                );
                return;
            }

            // ✅ FIX: get requisitionId correctly
            const requisitionId =
                data?.items?.[0]?.requisitionNo?._id;

            const requisitionNo =
                data?.items?.[0]?.requisitionNo?.requisitionNo;

            if (!requisitionId) {
                Swal.fire(
                    "Error",
                    "Requisition ID not found. Please refresh and try again.",
                    "error"
                );
                return;
            }

            // 3️⃣ Build items payload (ONLY SELECTED ITEMS)
            const itemsPayload = selectedItems.map(item => ({
                itemId: item._id,
                partNo: item.inventory.masterItem.partNo,
                description:
                    editedDescriptions[item._id] ||
                    item.inventory.masterItem.description,
                requiredQty: item.qtyRequired,
                approvedQty: item.approveQty
            }));

            // 4️⃣ Build & validate supplier payload
            const suppliersPayload = selectedSuppliers
                .map(s => ({
                    supplierId: s._id,
                    name: s.name,
                    phone: getValidWhatsAppNumber(s.mobileNo)
                }))
                .filter(s => s.phone);

            if (suppliersPayload.length === 0) {
                Swal.fire(
                    "Invalid WhatsApp Numbers",
                    "Selected suppliers do not have valid WhatsApp numbers",
                    "warning"
                );
                return;
            }

            // 5️⃣ Start sending (one quotation batch)
            setSending(true);

            await POServices.sendQuotationWhatsApp({
                requisitionId,          // ✅ CORRECT ID
                requisitionNo,          // ✅ NUMBER
                items: itemsPayload,    // ✅ selected parts
                suppliers: suppliersPayload
            });

            // 6️⃣ Success
            Swal.fire(
                "Success",
                "Quotation sent for selected part(s)",
                "success"
            );

            // Optional: clear selections for next batch
            setSelectedItems([]);
            setSelectedSuppliers([]);

        } catch (error) {
            console.error("Send quotation error:", error);

            Swal.fire(
                "Error",
                error?.response?.data?.message || "Failed to send quotation",
                "error"
            );
        } finally {
            setSending(false);
        }
    };



    const quotationPreview = selectedItems.flatMap(item =>
        selectedSuppliers.map(supplier => ({
            itemId: item._id,
            partNo: item.inventory.masterItem.partNo,
            description:
                editedDescriptions[item._id] ||
                item.inventory.masterItem.description,
            supplierName: supplier.name
        }))
    );


    return (
        <Modal
            className="fade"
            show={show}
            onHide={handleClose}
            enforceFocus={false}
            size="xl"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="fas fa-edit me-2"></i>Quotation Form
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Container fluid>

                    {/* ✅ SUPPLIER CHECKBOX SECTION WITH SEARCH */}
                    <Row className="mb-3">
                        <Col md="12">
                            <div className="border rounded p-2 bg-light">
                                <strong>Select Suppliers</strong>

                                {/* 🔍 Search Bar */}
                                <Form.Control
                                    type="text"
                                    placeholder="Search supplier..."
                                    className="my-2"
                                    value={supplierSearch}
                                    onChange={(e) => setSupplierSearch(e.target.value)}
                                />

                                <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                                    {filteredSuppliers.length > 0 ? (
                                        filteredSuppliers.map((supplier) => (
                                            <Form.Check
                                                key={supplier._id}
                                                type="checkbox"
                                                id={`supplier-${supplier._id}`}
                                                label={formatSupplierLabel(supplier)}
                                                checked={selectedSuppliers.some(
                                                    (s) => s._id === supplier._id
                                                )}
                                                onChange={(e) =>
                                                    handleSupplierCheck(supplier, e.target.checked)
                                                }
                                                className="mb-1"
                                            />
                                        ))
                                    ) : (
                                        <div className="text-muted text-center">
                                            No suppliers found
                                        </div>
                                    )}
                                </div>

                                <small className="text-muted">
                                    Selected: {selectedSuppliers.length}
                                </small>
                            </div>
                        </Col>
                    </Row>

                    {/* ✅ ITEMS TABLE (UNCHANGED LOOK) */}
                    <Row>
                        <Col md="12">
                            <div className="table-responsive" style={{ overflowX: 'auto' }}>
                                <table className="table table-bordered table-striped">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Select</th>
                                            <th>S.No</th>
                                            <th>Requisition No</th>
                                            <th>Part No</th>
                                            <th>Description</th>
                                            <th>Required Qty</th>
                                            <th>Approved Qty</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {Array.isArray(data?.items) && data.items.length > 0 ? (
                                            data.items.map((item, index) => (
                                                <tr key={item._id}>
                                                    <td>
                                                        <Form.Check
                                                            type="checkbox"
                                                            checked={selectedItems.some(i => i._id === item._id)}
                                                            onChange={(e) => {
                                                                setSelectedItems(prev =>
                                                                    e.target.checked
                                                                        ? [...prev, item]
                                                                        : prev.filter(i => i._id !== item._id)
                                                                );
                                                            }}
                                                        />
                                                    </td>

                                                    <td>{index + 1}</td>
                                                    <td>{data?.requisitionNo}</td>
                                                    <td>{item?.inventory?.masterItem?.partNo || "N/A"}</td>
                                                    <td>
                                                        <Form.Control
                                                            as="textarea"
                                                            rows={2}
                                                            placeholder="Edit description"
                                                            value={
                                                                editedDescriptions[item._id] ??
                                                                item?.inventory?.masterItem?.description ??
                                                                ""
                                                            }
                                                            onChange={(e) =>
                                                                setEditedDescriptions(prev => ({
                                                                    ...prev,
                                                                    [item._id]: e.target.value
                                                                }))
                                                            }

                                                        />
                                                    </td>
                                                    <td>{item?.qtyRequired ?? 0}</td>
                                                    <td>{item?.approveQty ?? 0}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="text-center text-muted">
                                                    No items found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                    </Row>

                </Container>
                {quotationPreview.length > 0 && (
                    <Row className="mt-4">
                        <Col md="12">
                            <h6 className="mb-2">
                                Quotation Preview (Selected Part(s) → Supplier(s))
                            </h6>

                            <div className="table-responsive">
                                <table className="table table-bordered table-striped">
                                    <thead className="table-light">
                                        <tr>
                                            <th>S.No</th>
                                            <th>Part No</th>
                                            <th>Description</th>
                                            <th>Supplier</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {quotationPreview.map((row, index) => (
                                            <tr key={`${row.itemId}-${row.supplierName}-${index}`}>
                                                <td>{index + 1}</td>
                                                <td>{row.partNo}</td>
                                                <td>{row.description}</td>
                                                <td>{row.supplierName}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <small className="text-muted">
                                This preview shows how quotations will be sent when you click WhatsApp.
                            </small>
                        </Col>
                    </Row>
                )}

            </Modal.Body>

            {/* ✅ FOOTER ACTIONS */}
            <Modal.Footer className="d-flex justify-content-end gap-3">
                {/* WhatsApp */}
                <Button
                    variant="success"
                    disabled={selectedSuppliers.length === 0 || sending}
                    onClick={handleSendQuotation}
                >
                    {sending ? "Sending..." : <i className="fab fa-whatsapp fs-4"></i>}
                </Button>

            </Modal.Footer>
        </Modal>
    );
};

export default React.memo(QuatationModal);
